module.exports = __webpack_public_path__ + "static/media/flowers_17.21724935.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_17.csv
// module id = 756
// module chunks = 0